<template>
    <div class="team-page">
        <layout>
            <template v-slot:search>
                <div class="search-wrapper">
                    <div class="title"><a-icon type="search" /> 数据筛选</div>
                    <a-divider></a-divider>
                    <a-space>
                      <a-select show-search allow-clear placeholder="所属主体" v-model="queryParam.corporation_id"  option-filter-prop="children">
                        <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id" >
                          {{ corporation.name }}
                        </a-select-option>
                      </a-select>
                      <a-input allow-clear placeholder="名称" v-model="queryParam.name" />
                      <a-button type="primary" @click="search">查询</a-button>
                      <a-button @click="resetSearch">重置</a-button>
                    </a-space>
                </div>
            </template>

            <template v-slot:content>
                <a-space class="table-operator">
                    <a-button type="primary" icon="plus" @click="create" v-if="accessTo('store')">添加</a-button>
                </a-space>

                <a-table
                  :columns="columns"
                  :row-key="record => record.id"
                  :data-source="data"
                  :pagination="pagination"
                  :loading="loading"
                  :transform-cell-text="$helper.emptyFormat"
                  @change="handleTableChange"
                >
                    <div slot="workers" slot-scope="workers">
                        <span v-if="workers">
                            <a-tag v-for="item in workers" :key="item.id">
                                {{item.username}}
                            </a-tag>
                        </span>
                        <span v-else> - </span>
                    </div>
                
                    <div slot="month_progress" slot-scope="month_progress" class="custom-progress">
                        <span v-if="month_progress !== null">
                            <a-progress  :percent="month_progress" strokeColor="#E3724E" :showInfo="false"  status="active" style="padding-right:60px;"/>
                            <span style="margin-left:-60px">  {{ month_progress }}% </span>
                          </span>
                          <span v-else>未填写月目标</span>
                    </div>

                    <div slot="action" slot-scope="record" class="actions">
                        <template v-if="accessTo('update')">
                            <a href="javascript:;" @click="create(record)" v-if="accessTo('update')">编辑</a>

                            <span v-if="accessToTeamTarget('index')">
                                <a-divider type="vertical"/>
                                <a href="javascript:;" @click="showTeamTarget(record)" v-if="accessToTeamTarget('index')">消耗目标</a>
                            </span>

                        </template>
                        <template v-else>-</template>
                    </div>
                </a-table>
            </template>
        </layout>
        <create-form
            v-if="showForm"
            :showForm.sync="showForm"
            :model="model"
            @success="refresh"
        />

        <team-target-page
            v-if="showTeamTargetPage"
            :showTeamTargetPage.sync="showTeamTargetPage"
            :model="model"
            @success="refresh"
        />
    </div>
</template>

<style lang="less" scoped>
@import 'Team';
</style>

<script>
import Team from './Team'
export default Team
</script>
